import { useState } from 'react';

/**
 * Sometimes, you need to keep track of multiple in-flight requests and do something when they are
 * all finished. The `makeRequest` function returned from this hook can be used to send any amount
 * of asynchronous requests, and `isLoading` keeps track of whether any requests are still in
 * flight.
 */
export const useBatchedLoading = () => {
  const [inFlight, setInFlight] = useState(0);

  const makeRequest = <T>(cb: () => Promise<T>): Promise<T> => {
    setInFlight(i => i + 1);

    return cb().finally(() => setInFlight(i => i - 1));
  };

  return {
    makeRequest,
    isLoading: inFlight !== 0,
  };
};
